webpackJsonp([74],{

/***/ 2411:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenstrualCalendar_vue__ = __webpack_require__(3514);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93008142_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenstrualCalendar_vue__ = __webpack_require__(4079);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4073)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-93008142"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenstrualCalendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93008142_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenstrualCalendar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/clinicHistory/MenstrualCalendar.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-93008142", Component.options)
  } else {
    hotAPI.reload("data-v-93008142", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2471:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_sessionStorage__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__ = __webpack_require__(1274);
/* harmony default export */ __webpack_exports__["a"] = ({methods:{goToSection:function goToSection(path){var needsPatientId=!this.$store.getters['session/userIsPatient']&&this.$route.query.patientId;var route={path:''+__WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__["d" /* BASE_PATH */]+(path!==__WEBPACK_IMPORTED_MODULE_1__constants_clinicHistory__["P" /* MENU_PATH */]?'/'+path:''),query:{}};if(needsPatientId)route.query.patientId=this.$route.query.patientId;if(this.$route.query.petId)route.query.petId=this.$route.query.petId;this.$router.push(route).catch(function(){});}},data:function data(){return{historyReadOnly:!!sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_0__constants_sessionStorage__["a" /* READ_ONLY_TOKEN_SESSION_STORAGE_KEY */])};},watch:{items:function items(value){this.$emit('anyItemSelected',value&&value.length>0);},zeroItems:function zeroItems(value){this.$emit('anyItemSelected',value);}}});

/***/ }),

/***/ 2477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddButton_vue__ = __webpack_require__(2556);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38b0fcd7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddButton_vue__ = __webpack_require__(2604);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2602)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38b0fcd7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/buttons/AddButton.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-38b0fcd7", Component.options)
  } else {
    hotAPI.reload("data-v-38b0fcd7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-button',
  props: {
    buttonText: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('add-btn');
      }
    },
    showTextOnMobile: Boolean
  },
  computed: {
    btnText: function btnText() {
      return this.$uiHelpers.isMobile && !this.showTextOnMobile ? '' : this.buttonText;
    }
  },
  data: function data() {
    return {
      hover: false
    };
  }
});

/***/ }),

/***/ 2602:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2603);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("1c10b383", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38b0fcd7\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddButton.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-38b0fcd7\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./AddButton.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2603:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 2604:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("icon-button", {
    attrs: {
      icon: "/static-appopensalud/img/icons/morillas-svg-icons/primary/add.svg",
      text: _vm.btnText
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38b0fcd7", esExports)
  }
}

/***/ }),

/***/ 3514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CycleChart_vue__ = __webpack_require__(4075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repositories_PatientsRepository__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_clinicHistory__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_clinicHistory_mixin__ = __webpack_require__(2471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_base_buttons_AddButton__ = __webpack_require__(2477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_base_forms_BaseDatepicker__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_base_BaseDialog__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_date_helpers__ = __webpack_require__(182);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'menstrual-calendar',
  components: {
    CycleChart: __WEBPACK_IMPORTED_MODULE_2__CycleChart_vue__["a" /* default */],
    BaseDialog: __WEBPACK_IMPORTED_MODULE_8__components_base_BaseDialog__["default"],
    AddButton: __WEBPACK_IMPORTED_MODULE_6__components_base_buttons_AddButton__["a" /* default */],
    BaseDatepicker: __WEBPACK_IMPORTED_MODULE_7__components_base_forms_BaseDatepicker__["default"]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_clinicHistory_mixin__["a" /* default */]],
  data: function data() {
    return {
      startDate: '',
      MENU_PATH: __WEBPACK_IMPORTED_MODULE_4__constants_clinicHistory__["P" /* MENU_PATH */],
      visibleEndCurrentCycle: false,
      confirmEnd: false,
      allowAdd: false,
      visibleSetPeriod: false,
      showAddSection: false,
      cycles: [],
      currentCycle: null,
      mostRecentCycle: null,
      newCyclePrediction: null,
      periodDuration: null
    };
  },

  computed: {
    tooltipText: function tooltipText() {
      return '\n        <div><span style="display: inline-block;width: 10px;height: 10px;border-radius: 50%;margin-right: 5px;background-color: red"></span> ' + this.$t('periodDuration2') + '</div>\n        <div><span style="display: inline-block;width: 10px;height: 10px;border-radius: 50%;margin-right: 5px;background-color: orange"></span> ' + this.$t('ovulationDurationPrediction') + '</div>\n        <div><span style="display: inline-block;width: 10px;height: 10px;border-radius: 50%;margin-right: 5px;background-color: lightblue"></span> ' + this.$t('ovulationDuration') + '</div>\n      ';
    }
  },
  methods: {
    getCycles: function getCycles() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__repositories_PatientsRepository__["a" /* default */].getMenstruations();

              case 3:
                response = _context.sent;

                if (response.data.length > 0) {
                  _this.cycles = response.data.sort(function (a, b) {
                    return new Date(b.dateStartCycle) - new Date(a.dateStartCycle);
                  });
                  _this.currentCycle = _this.cycles.find(function (cycle) {
                    return !cycle.cycleDuration && cycle.periodDuration;
                  });
                  _this.mostRecentCycle = _this.cycles[0];
                  _this.allowAdd = _this.mostRecentCycle.periodDuration != null;
                } else {
                  _this.allowAdd = true;
                }
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                _this.$store.dispatch('showDangerAlert', _this.$t('error-cycles-get'));

              case 10:
                if (_this.mostRecentCycle) {
                  _this.newCyclePrediction = new Date(_this.mostRecentCycle.dateStartCycle);
                  _this.newCyclePrediction.setDate(_this.newCyclePrediction.getDate() + _this.calculateAverageCycleLength());
                }

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    deleteCycle: function deleteCycle(idCycle) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__repositories_PatientsRepository__["a" /* default */].deleteMenstruation(idCycle);

              case 3:
                response = _context2.sent;

                if (response.data === true) {
                  _this2.cycles = _this2.cycles.filter(function (cycle) {
                    return cycle.idCycle !== idCycle;
                  });
                  _this2.getCycles();
                } else {
                  console.error('error');
                }
                _context2.next = 10;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](0);

                _this2.$store.dispatch('showDangerAlert', _this2.$t('error-cycles-delete'));

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 7]]);
      }))();
    },
    setVisiblePeriodLength: function setVisiblePeriodLength() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.visibleSetPeriod = true;

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    setPeriodDuration: function setPeriodDuration(cycle) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this4.periodDuration) {
                  _context4.next = 12;
                  break;
                }

                _context4.prev = 1;
                _context4.next = 4;
                return _this4.updateCycle({ idCycle: cycle.idCycle, periodDuration: parseInt(_this4.periodDuration) });

              case 4:
                _this4.visibleSetPeriod = false;
                _this4.periodDuration = null;
                _this4.getCycles();
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](1);

                _this4.$store.dispatch('showDangerAlert', _this4.$t('error-cycles-set'));

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[1, 9]]);
      }))();
    },
    addDaysToDate: function addDaysToDate(dateString, days) {
      var date = new Date(dateString);
      date.setDate(date.getDate() + days - 1);
      return date;
    },
    clickToVisiblePeriod: function clickToVisiblePeriod() {
      this.visibleSetPeriod = true;
    },
    addNewCycleForm: function addNewCycleForm() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this5.currentCycle) {
                  _this5.visibleEndCurrentCycle = true;
                } else {
                  _this5.startNewCycle();
                }
                _this5.showAddSection = true;

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    startNewCycle: function startNewCycle() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var newCycle;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                newCycle = {
                  dateStartCycle: new Date(_this6.startDate).toISOString()
                };
                _context6.prev = 1;
                _context6.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3__repositories_PatientsRepository__["a" /* default */].postMenstruation(newCycle);

              case 4:
                _this6.getCycles(); // Recargar los ciclos
                _this6.startDate = null;
                _this6.showAddSection = false;
                _context6.next = 12;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6['catch'](1);

                _this6.$store.dispatch('showDangerAlert', _this6.$t('error-cycles-start'));

              case 12:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[1, 9]]);
      }))();
    },
    endCurrentCycle: function endCurrentCycle() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var newCycleStartDate, currentCycleStartDate, cycleDuration;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this7.visibleEndCurrentCycle = false;
                newCycleStartDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(_this7.startDate).startOf('day');
                currentCycleStartDate = __WEBPACK_IMPORTED_MODULE_9_moment___default()(_this7.currentCycle.dateStartCycle).startOf('day');
                cycleDuration = newCycleStartDate.diff(currentCycleStartDate, 'days');
                _context7.prev = 4;
                _context7.next = 7;
                return _this7.updateCycle({ idCycle: _this7.currentCycle.idCycle, cycleDuration: cycleDuration });

              case 7:
                _this7.currentCycle = null;
                _context7.next = 10;
                return _this7.startNewCycle();

              case 10:
                _this7.getCycles();
                _context7.next = 16;
                break;

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7['catch'](4);

                _this7.$store.dispatch('showDangerAlert', _this7.$t('error-cycles-delete'));

              case 16:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7, [[4, 13]]);
      }))();
    },
    updateCycle: function updateCycle(updatedCycleData) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3__repositories_PatientsRepository__["a" /* default */].putMenstruation(updatedCycleData);

              case 3:
                _this8.getCycles();
                _context8.next = 9;
                break;

              case 6:
                _context8.prev = 6;
                _context8.t0 = _context8['catch'](0);

                _this8.$store.dispatch('showDangerAlert', _this8.$t('error-cycles-set2'));

              case 9:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8, [[0, 6]]);
      }))();
    },
    formatDate: function formatDate(dateString) {
      return Object(__WEBPACK_IMPORTED_MODULE_10__helpers_date_helpers__["a" /* appointmentDateFormat */])(dateString, true, true);
    },
    calculateOvulationMonthDays: function calculateOvulationMonthDays(startDate, cycleDuration) {
      var ovulationDay = Math.floor(cycleDuration / 2);
      var ovulationStart = ovulationDay - 3; // restamos 3 y sumamos 2 para obtener seis días que son los que dura la ovulación
      var ovulationEnd = ovulationDay + 2;
      var ovulationDays = [];
      for (var i = ovulationStart; i <= ovulationEnd; i++) {
        var ovulationDate = new Date(startDate);
        ovulationDate.setDate(ovulationDate.getDate() + i);
        ovulationDays.push(ovulationDate.getDate());
      }
      return ovulationDays;
    },
    calculateAverageCycleLength: function calculateAverageCycleLength() {
      // Filtrar ciclos finalizados y con duración válida
      var completedCycles = this.cycles.filter(function (cycle) {
        return cycle.cycleDuration;
      });
      if (completedCycles.length === 0) {
        return 27;
      }
      var totalDuration = completedCycles.reduce(function (sum, cycle) {
        return sum + cycle.cycleDuration;
      }, 0);
      return Math.round(totalDuration / completedCycles.length);
    },
    displayFertileDays: function displayFertileDays() {
      var cycleDuration = this.calculateAverageCycleLength();
      var fertileDays = this.calculateOvulationMonthDays(this.mostRecentCycle.dateStartCycle, cycleDuration);
      return fertileDays.join(', ');
    }
  },
  mounted: function mounted() {
    this.getCycles();
  }
});

/***/ }),

/***/ 3515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);

//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    startDate: {
      type: String,
      required: true
    },
    cycleLength: {
      type: Number,
      default: 28
    },
    periodLength: {
      type: Number,
      default: 4
    },
    predictedCycleLength: {
      type: Number,
      default: 27 // Predicción de duración del ciclo si no está finalizado
    }
  },
  computed: {
    effectiveCycleLength: function effectiveCycleLength() {
      return this.cycleLength || this.predictedCycleLength;
    },
    periodDays: function periodDays() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: this.periodLength }, function (_, i) {
        return i;
      });
    },
    ovulationDays: function ovulationDays() {
      var ovulationDays = 6;
      var ovulationBegin = 3; // De forma general dividiendo la duración del ciclo entre 2 nos situamos en mitad de la ovulación, como ésta dura seis días restando 3 tenemos el día que comienza
      var ovulationDay = Math.floor(this.effectiveCycleLength / 2);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()({ length: ovulationDays }, function (_, i) {
        return ovulationDay - ovulationBegin + i;
      });
    }
  },
  methods: {
    getDayClass: function getDayClass(index) {
      if (this.periodDays.includes(index)) {
        return 'period-day';
      } else if (this.ovulationDays.includes(index)) {
        return this.cycleLength ? 'ovulation-day' : 'predicted-ovulation-day';
      } else {
        return 'normal-day';
      }
    }
  }
});

/***/ }),

/***/ 4073:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4074);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("2fe83f9c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-93008142\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MenstrualCalendar.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-93008142\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./MenstrualCalendar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4074:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-93008142]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-93008142],.slide-down-leave-active[data-v-93008142]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-93008142],.slide-down-leave-to[data-v-93008142]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-93008142],.slide-fade-left-leave-active[data-v-93008142]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-93008142],.slide-fade-left-leave-to[data-v-93008142]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-93008142]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-93008142],.fade-leave-to[data-v-93008142]{opacity:0\n}\n.d-flex[data-v-93008142]{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.flex-column[data-v-93008142]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n.flex-md-row[data-v-93008142]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row\n}\n.align-items-center[data-v-93008142]{-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n.cycle-form[data-v-93008142]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between\n}\n.control-ciclos[data-v-93008142]{margin:20px\n}\nform[data-v-93008142]{margin-bottom:20px\n}\n.btn-background[data-v-93008142]{background-color:transparent !important;border-color:transparent !important\n}\n.no-cycles[data-v-93008142]{margin-top:20px;font-size:16px;color:#888;text-align:center\n}\n.cycle-item[data-v-93008142]{padding:0;margin:0;list-style-type:none\n}\n@media only screen and (max-width: 575px){\n.cycle-item[data-v-93008142]{padding-left:0\n}\n}\n.cycle-card[data-v-93008142]{padding:10px;border-radius:5px;margin-bottom:20px;overflow:hidden\n}\n.delete-text[data-v-93008142]{color:red;cursor:pointer\n}\n.input-container[data-v-93008142]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n@media only screen and (min-width: 1024px){\n.input-container[data-v-93008142]{margin:1rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.input-container[data-v-93008142]{margin:1rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.input-container[data-v-93008142]{margin:1rem;max-width:100% !important\n}\n}\n.inputAnswer[data-v-93008142]{margin-right:10px\n}\n.days-text[data-v-93008142]{margin-left:5px\n}\n.add-text[data-v-93008142]{margin-left:10px;cursor:pointer;color:#3238C4\n}\n.delete-text[data-v-93008142]:hover{text-decoration:underline\n}\n", ""]);

// exports


/***/ }),

/***/ 4075:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CycleChart_vue__ = __webpack_require__(3515);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b6922a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CycleChart_vue__ = __webpack_require__(4078);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(4076)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b6922a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CycleChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b6922a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CycleChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/clinicHistory/CycleChart.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5b6922a8", Component.options)
  } else {
    hotAPI.reload("data-v-5b6922a8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 4076:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4077);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("c9892d60", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5b6922a8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CycleChart.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5b6922a8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CycleChart.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 4077:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.cycle-tracker[data-v-5b6922a8] {\r\n  font-family: Arial, sans-serif;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\n}\n.cycle-bar[data-v-5b6922a8] {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  margin-bottom: 10px;\n}\n.predicted-ovulation-day[data-v-5b6922a8] {\r\n  background-color: orange\n}\n.cycle-day[data-v-5b6922a8] {\r\n  width: 15px;\r\n  height: 15px;\r\n  border-radius: 50%;\r\n  margin: 0 2px;\n}\n.period-day[data-v-5b6922a8] {\r\n  background-color: red\n}\n.ovulation-day[data-v-5b6922a8] {\r\n  background-color: lightblue\n}\n.normal-day[data-v-5b6922a8] {\r\n  background-color: rgb(213, 213, 213)\n}\n.cycle-info[data-v-5b6922a8] {\r\n  margin-top: 10px\n}\r\n", ""]);

// exports


/***/ }),

/***/ 4078:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cycle-tracker" }, [
    _c(
      "div",
      { staticClass: "cycle-bar" },
      _vm._l(_vm.effectiveCycleLength, function(day, index) {
        return _c("div", {
          key: index,
          staticClass: "cycle-day",
          class: _vm.getDayClass(index)
        })
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b6922a8", esExports)
  }
}

/***/ }),

/***/ 4079:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "mb-5" },
      [
        _c(
          "base-card",
          {
            attrs: {
              overflowVisible: "",
              title: _vm.$t("cycleControl"),
              info: _vm.tooltipText,
              hideButtons: _vm.historyReadOnly
            },
            on: {
              rightBtnClick: function($event) {
                _vm.showAddSection = true
              }
            }
          },
          [
            !_vm.showAddSection
              ? _c(
                  "template",
                  {
                    slot:
                      _vm.$uiHelpers.isMobile || _vm.$uiHelpers.isTablet
                        ? "append-btn-title"
                        : "right-button"
                  },
                  [
                    _c("add-button", {
                      attrs: { buttonText: _vm.$t("new-cycle") },
                      on: { click: _vm.addNewCycleForm }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showAddSection
              ? _c(
                  "form",
                  {
                    staticClass:
                      "d-flex flex-column flex-md-row align-items-start form-section",
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.addNewCycleForm.apply(null, arguments)
                      }
                    }
                  },
                  [
                    !_vm.allowAdd
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("mustSetPeriod")))])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.allowAdd
                      ? _c(
                          "b-col",
                          {
                            staticClass: "mb-2 mb-md-0 mx-md-2",
                            attrs: { cols: "12", md: "3" }
                          },
                          [
                            _c("base-datepicker", {
                              attrs: {
                                max: new Date(),
                                placeholder: _vm.$t("cycleStartDate"),
                                "value-as-date": ""
                              },
                              model: {
                                value: _vm.startDate,
                                callback: function($$v) {
                                  _vm.startDate = $$v
                                },
                                expression: "startDate"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "add-text",
                                on: {
                                  click: function() {
                                    return (_vm.showAddSection = false)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("back")))]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.allowAdd
                      ? _c(
                          "b-col",
                          {
                            staticClass:
                              "d-flex justify-content-md-start justify-content-center",
                            attrs: { cols: "12" }
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  type: "submit",
                                  disabled: !_vm.startDate
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("startCycle")))]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.cycles.length > 0
              ? _c("div", { staticClass: "results mt-4" }, [
                  _c(
                    "ul",
                    { staticClass: "cycle-item" },
                    [
                      _c("h4", [_vm._v(_vm._s(_vm.$t("historyCycle")))]),
                      _vm._v(" "),
                      _vm._l(_vm.cycles, function(cycle) {
                        return _c(
                          "li",
                          { key: cycle.idCycle, staticClass: "cycle-card" },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.$t("cycle")) +
                                  " " +
                                  _vm._s(
                                    cycle.cycleDuration
                                      ? _vm.formatDate(cycle.dateStartCycle)
                                      : _vm.$t("current") +
                                          " " +
                                          _vm.formatDate(cycle.dateStartCycle)
                                  ) +
                                  " " +
                                  _vm._s(
                                    cycle.cycleDuration != null
                                      ? _vm.$t("until") +
                                          " " +
                                          _vm.formatDate(
                                            _vm.addDaysToDate(
                                              cycle.dateStartCycle,
                                              cycle.cycleDuration
                                            )
                                          )
                                      : ""
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            cycle.cycleDuration
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("cycleDuration2")) +
                                      ": " +
                                      _vm._s(cycle.cycleDuration) +
                                      " " +
                                      _vm._s(_vm.$t("days"))
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            cycle.periodDuration
                              ? _c("div", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("periodDuration2")) +
                                        ": " +
                                        _vm._s(cycle.periodDuration) +
                                        " " +
                                        _vm._s(_vm.$t("days"))
                                    )
                                  ])
                                ])
                              : _c("div", [
                                  !_vm.visibleSetPeriod
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "btn btn-secondary btn-background",
                                          on: {
                                            click: function($event) {
                                              return _vm.setVisiblePeriodLength()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("setPeriodDuration"))
                                          )
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass:
                                                "mb-2 mb-md-0 mx-md-2 input-container",
                                              attrs: { cols: "12", md: "3" }
                                            },
                                            [
                                              _c(
                                                "base-input",
                                                {
                                                  staticClass: "inputAnswer",
                                                  attrs: {
                                                    min: "0",
                                                    type: "number",
                                                    placeholder: _vm.$t(
                                                      "periodDuration2"
                                                    )
                                                  },
                                                  model: {
                                                    value: _vm.periodDuration,
                                                    callback: function($$v) {
                                                      _vm.periodDuration = $$v
                                                    },
                                                    expression: "periodDuration"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "append" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "days-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("days")
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "add-text",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setPeriodDuration(
                                                        cycle
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("add-txt"))
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                ]),
                            _vm._v(" "),
                            cycle.cycleDuration
                              ? _c("div", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("ovulationDuration")) +
                                      ": " +
                                      _vm._s(
                                        _vm
                                          .calculateOvulationMonthDays(
                                            cycle.dateStartCycle,
                                            cycle.cycleDuration
                                          )
                                          .join(", ")
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _c("div", [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("ovulationDurationPrediction")
                                      ) +
                                        ": " +
                                        _vm._s(_vm.displayFertileDays())
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.$t("newCyclePredictionDate")) +
                                        ": " +
                                        _vm._s(
                                          _vm.formatDate(_vm.newCyclePrediction)
                                        )
                                    )
                                  ])
                                ]),
                            _vm._v(" "),
                            _c("CycleChart", {
                              attrs: {
                                startDate: cycle.dateStartCycle,
                                cycleLength: cycle.cycleDuration,
                                predictedCycleLength: _vm.calculateAverageCycleLength(),
                                periodLength: cycle.periodDuration
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "delete-text",
                                on: {
                                  click: function($event) {
                                    return _vm.deleteCycle(cycle.idCycle)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("delete")))]
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ])
              : _c("div", { staticClass: "no-cycles" }, [
                  _c("p", [_vm._v(_vm._s(_vm.$t("noControl")))])
                ]),
            _vm._v(" "),
            _c("base-dialog", {
              attrs: {
                content: _vm.$t("confirmEndCurrentCycle"),
                okFn: function async() {
                  _vm.endCurrentCycle()
                },
                cancelFn: function() {
                  _vm.visibleEndCurrentCycle = false
                }
              },
              model: {
                value: _vm.visibleEndCurrentCycle,
                callback: function($$v) {
                  _vm.visibleEndCurrentCycle = $$v
                },
                expression: "visibleEndCurrentCycle"
              }
            })
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-93008142", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/74.dd412195d32c5c8e0ab8.js